import { createContext } from "react"

const undefinedFunctionWarning = (fnName: string) => (..._args: unknown[]) => console.warn(`function ${fnName} is not defined`)

export type WebSocketStatus = "connecting" | "open" | "closed"

export interface WebSocketCallbacks {
    onOpen?: (_event: Event, _webSocket: WebSocket) => void
    onMessage?: (_event: MessageEvent, _webSocket: WebSocket) => void
    onClose?: (_event: CloseEvent, _webSocket: WebSocket) => void
    onError?: (_event: Event, _webSocket: WebSocket) => void
}

export interface LaunchWebSocketParams extends WebSocketCallbacks {
    id: string
    url: string
    protocols?: string | string[]
}

export interface WebSocketEntry {
    id: string
    webSocket: WebSocket
    status: WebSocketStatus
    progress: number
}

export interface WSStateType {
    webSockets: Record<string, WebSocketEntry>
}

export interface WSDispatchType {
    launchWebSocket: (_params: LaunchWebSocketParams) => void
    closeWebSocket: (_id: string) => void
    setWebSocketProgress: (_id: string, _progress: number) => void
}

export const initialState: WSStateType = {
    webSockets: {},
}

const initialDispatch: WSDispatchType = {
    launchWebSocket: undefinedFunctionWarning("launchWebSocket"),
    closeWebSocket: undefinedFunctionWarning("closeWebSocket"),
    setWebSocketProgress: undefinedFunctionWarning("setWebSocketProgress"),
}

export const WSStateContext = createContext<WSStateType>(initialState)
export const WSDispatchContext = createContext<WSDispatchType>(initialDispatch)
